import Alignment from '@tiptap/extension-text-align';

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		textAlign: {
			/**
			* Set the text align attribute
			*/
			setTextAlign: (alignment: string) => ReturnType;
			/**
			* Unset the text align attribute
			*/
			unsetTextAlign: () => ReturnType;
		};
	}
}

export const TrAlignment = Alignment.extend({
	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					textAlign: {
						default: this.options.defaultAlignment,
						parseHTML: (element) => element.style.textAlign || element.dataset.textAlign || this.options.defaultAlignment,
						renderHTML: (attributes) => {
							if (attributes.textAlign === this.options.defaultAlignment) {
								return {};
							}

							return {
								'data-text-align': attributes.textAlign,
								style: `text-align: ${attributes.textAlign}`,
							};
						},
					},
				},
			},
		];
	},
});
